<template>
  <v-list nav dense>
    <v-img
      :src="
        accountSettings && accountSettings.logo_url
          ? accountSettings.logo_url
          : require('./assets/' + $t('$assets.fullLogoSmallWhite'))
      "
      contain
      width="144"
      class="my-4 ms-8 d-none d-lg-flex"
    />
    <div class="my-1 d-flex d-lg-none" />
    <v-list-item
      v-if="settingMode"
      color="sidebarActive"
      :key="$t('SettingNav.backHome')"
      @click.stop="$emit('backToHome')"
      link
    >
      <v-list-item-action class="ms-5 me-2">
        <v-icon>fa-home</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title class="my-n3">
          {{ $t("SettingNav.backHome") }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <template v-for="item in items">
      <v-list-group
        color="sidebarActive"
        v-if="item.subitems"
        :key="item.title"
        v-model="item.model"
        class="mb-1"
      >
        <template v-slot:activator>
          <v-list-item-action class="ms-5 me-2">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content class="me-n16">
            <v-list-item-title class="me-n16 my-n3">
              <v-badge
                :color="item.badge > 0 ? 'accent' : 'transparent'"
                :label="item.badge > 999 ? '999+' : '' + item.badge"
                :content="item.badge > 999 ? '999+' : item.badge"
                offset-y="10"
                offset-x="0"
                class="my-5"
                >{{ item.title }}
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item
          color="sidebarActive"
          v-for="(child, i) in item.subitems"
          :key="i"
          v-model="child.model"
          :href="'/#' + child.link"
          link
        >
          <v-list-item-action v-if="child.icon">
            <v-icon>
              {{ child.icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="ms-15 my-n3">
              <v-badge
                :color="child.badge > 0 ? 'accent' : 'transparent'"
                :label="child.badge > 999 ? '999+' : '' + child.badge"
                :content="child.badge > 999 ? '999+' : child.badge"
                offset-y="10"
                offset-x="0"
                class="my-5"
                >{{ child.title }}
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item
        color="sidebarActive"
        v-else
        :key="item.title"
        v-model="item.model"
        :href="'/#' + item.link"
        link
      >
        <v-list-item-action class="ms-5 me-2">
          <v-icon>
            {{ item.icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="my-n3">
            <v-badge
              :color="item.badge > 0 ? 'accent' : 'transparent'"
              :label="item.badge > 999 ? '999+' : '' + item.badge"
              :content="item.badge > 999 ? '999+' : item.badge"
              offset-y="10"
              offset-x="0"
              class="my-5"
              >{{ item.title }}
            </v-badge>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<style scoped>
.v-icon.v-icon {
  font-size: 12px;
  width: 20px;
  text-align: center;
}
</style>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";

// var homeNav = {
//   title: i18n.t("Nav.home"),
//   icon: "fa-home",
//   link: "/home",
//   model: true,
// };

export default {
  name: "Nav",

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["allow", "settings", "accountSettings", "userType"]),
  },

  props: {
    settingMode: Boolean,
    login: Object,
    locale: String,
  },

  data: () => ({
    items: [],
  }),

  watch: {
    $route() {
      this.items = this.makeItems();
    },
    settingMode: {
      immediate: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    locale: {
      immediate: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    allow: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    accountSettings: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    },
    userType: {
      immediate: true,
      deep: true,
      handler() {
        this.items = this.makeItems();
      },
    }
  },

  methods: {
    makeItems() {
      var nav = [];
      var navItems = [];
      if (!this.settingMode) {
        // nav.push(
        //   Object.assign({}, homeNav, {
        //     model:
        //       this.$route.path == homeNav.link ||
        //       this.$route.path.startsWith(homeNav.link + "/"),
        //   })
        // );
        navItems = this.navs();
      } else {
        navItems = this.settingNavs();
      }

      if (this.allow) {
        navItems.forEach((item) => {
          if (item.subitems) {
            var allowedSubitems = [];
            var itemModel = false;
            var itemBadge = 0;
            item.subitems.forEach((subitem) => {
              let controller = this.allow[subitem.controller];
              if (!subitem.controller) {
                subitem.model =
                        this.$route.path == subitem.link ||
                        this.$route.path.startsWith(subitem.link + "/");
                itemModel = itemModel || subitem.model;
                itemBadge += subitem.badge ? subitem.badge : 0;
                allowedSubitems.push(subitem);
              } else if (controller) {
                if (
                        controller.find((action) => subitem.action == action) &&
                        (!subitem.show || subitem.show())
                ) {
                  subitem.model = this.$route.path == subitem.link || this.$route.path.startsWith(subitem.link + "/");
                  itemModel = itemModel || subitem.model;
                  itemBadge += subitem.badge ? parseInt(subitem.badge) : 0;
                  allowedSubitems.push(subitem);
                }
              }
            });
            if (allowedSubitems.length > 0) {
              item.subitems = allowedSubitems;
              item.model = itemModel;
              item.badge = itemBadge;
              nav.push(item);
            }
          } else {
            if (!item.show || item.show()) {
              item.model =
                this.$route.path == item.link ||
                this.$route.path.startsWith(item.link + "/");
              nav.push(item);
            }
          }
        });
      }
      return nav;
    },
    navs() {
      return [
        {
          title: i18n.t("Nav.orderManagement"),
          icon: "fa-shopping-cart",
          link: "/orders",
          subitems: [
            {
              title: i18n.t("Nav.orderNew"),
              link: "/order-new",
              controller: "Orders",
              action: "index",
              show: function () {
                return this.$permission.permissionAllow("Orders", "add");
              }.bind(this),
            },
            {
              title: i18n.t("Nav.orders"),
              link: "/orders",
              controller: "Orders",
              action: "index",
              // badge:
              //         this.todos && this.todos.order
              //                 ? this.todos.order.wait_confirm_count
              //                 : 0,
            },
            {
              title: i18n.t("Nav.examines"),
              link: "/examines",
              controller: "Examines",
              action: "index",
            },
          ],
        },
        {
          title: i18n.t("Nav.returnOrderManagement"),
          icon: "fa-truck-loading",
          link: "/return-orders",
          subitems: [
            {
              title: i18n.t("Nav.returnOrderNew"),
              link: "/return-order-new",
              controller: "ReturnOrders",
              action: "add",
              show: function () {
                return this.userType == 0 && this.accountSettings && this.accountSettings.shop_return_order_enable;
              }.bind(this),
            },
            {
              title: i18n.t("Nav.returnOrders"),
              link: "/return-orders",
              controller: "ReturnOrders",
              action: "index",
              show: function () {
                return this.userType == 0 && this.accountSettings && this.accountSettings.shop_return_order_enable;
              }.bind(this),
            },
          ],
        },
        {
          title: i18n.t("Nav.fundManagement"),
          icon: "fa-chart-bar",
          link: "/receipts",
          subitems: [
            {
              title: i18n.t("Nav.receipt"),
              link: "/receipts",
              controller: "Receipt",
              action: "index",
            },
          ],
        },
        {
          title: i18n.t("Nav.stockManagement"),
          icon: "fa-calculator",
          link: "/stocks",
          subitems: [
            {
              title: i18n.t("Nav.currentStocks"),
              link: "/current-stocks",
              controller: "StockMaterials",
              action: "index",
            },
            {
              title: i18n.t("Nav.stockInOrders"),
              link: "/stock-in-orders",
              controller: "StockInOrders",
              action: "index",
            },
            {
              title: i18n.t("Nav.stockOutOrders"),
              link: "/stock-out-orders",
              controller: "StockOutOrders",
              action: "index",
            },
            {
              title: i18n.t("Nav.stockTakes"),
              link: "/stock-takes",
              controller: "StockTakes",
              action: "index",
            },
            {
              title: i18n.t("Nav.stockDetails"),
              link: "/stock-details",
              controller: "StockDetails",
              action: "index",
            },
            {
              title: i18n.t("Nav.stockOrderAnalyze"),
              link: "/stock-order-analyze",
              controller: "StockOrderAnalyze",
              action: "index",
            },
          ],
        },
        {
          title: i18n.t("Nav.productionManagement"),
          icon: "fa-cubes",
          subitems: [
            {
              title: i18n.t("Nav.productionPlans"),
              link: "/production-plans",
              controller: "ProductionPlans",
              action: "index"
            },
            {
              title: i18n.t("Nav.productionStockOUT"),
              link: "/production-stock-out",
              controller: "ProductionPlans",
              action: "outs"
            },
            {
              title: i18n.t("Nav.productionStockIN"),
              link: "/production-stock-in",
              controller: "ProductionPlans",
              action: "ins"
            },
          ],
        },
        {
          title: i18n.t("Nav.userCenter"),
          icon: "fa-cog",
          link: "/user",
          subitems: [
            {
              title: i18n.t("Nav.userInfo"),
              link: "/user",
              controller: "ShopUsers",
              action: "getUserInfo",
            },
          ],
        },
        {
          title: i18n.t("Nav.reportCenter"),
          icon: "fa-table",
          link: "/report-downloads",
          subitems: [
            {
              title: i18n.t("Nav.shopDailyReports"),
              link: "/shop-daily-reports",
              controller: "ShopDailyReports",
              action: "index",
            },
            {
              title: i18n.t("Nav.reportDownloads"),
              link: "/report-downloads",
              controller: "ReportDownloads",
              action: "index",
            },
          ],
        },
      ];
    },
    settingNavs() {
      return [];
    },
  },
};
</script>